import { combineReducers } from 'redux'

import { article } from './article';
import { articles } from './articles';
import { camp } from './camp';
import { events } from './events';
import { discoverFeed } from './discoverFeed';
import { feed } from './feed';
import { interests } from './interests';
import { notifications } from './notifications';
import { profile } from './profiles';
import { registration } from './registration';
import { search } from './search';
import { session } from './session';
import { verification } from './verification';
import { video } from './video';
import { workshop } from './workshop';
import { workshops } from './workshops';


export default combineReducers({
	article,
	articles,
	camp,
	events,
	discoverFeed,
	feed,
	interests,
	notifications,
	profile,
	registration,
	search,
	session,
	verification,
	video,
	workshop,
	workshops
})



// WEBPACK FOOTER //
// ./src/js/reducers/index.js